export enum OCPSDataStorePolicyValue {
    NotConfigured = 0,
    Enabled = 1,
    Disabled = 2,
}

export interface OCPSDataStoreType {
    /**
     * <key,value> pair of policies and their value
     */
    policies: Record<string, OCPSDataStorePolicyValue>;
    /**
     * Expiration date-time for the policies in ISO format
     */
    policyExpirationDate: string;
    /**
     * Did fetching policies result into an error scenario
     */
    hasError?: boolean;

    /**
     * Defines what error occurred during fetch of policies
     */
    errorMessage?: string;
}
